(function () {
    'use strict';
    $(document).ready(function () {

        if($('.homepage').length) {
            $(".play-video").modalVideo({
                channel: 'vimeo'
            });

            if (window.matchMedia("(min-width: 1024px)").matches) {

                $(window).on('scroll', function () {
                    var top = $(this).scrollTop();
                    if (top > 100) {
                        tlIntroWhiteBg.reverse();
                        introWhiteBgState = false;

                        tlIntroBlueBg.reverse();
                        introBlueBgState = false;

                        $('.segment-toggle').children('.toggle').removeClass('open');
                    }
                });

                var introWhiteBgState = false;
                var introBlueBgState = false;

                //Intro white bg animation

                var tlIntroWhiteBg = gsap.timeline({paused: true});
                tlIntroWhiteBg.to(".segment-blue-bg", {autoAlpha: 0, duration: .5});
                tlIntroWhiteBg.to(".homepage-skew", {x: "+=375", duration: .5}, "-=.25");
                tlIntroWhiteBg.to(".intro-image", {x: "+=300", scaleX: 0.75, scaleY: 0.75, duration: .5}, "-=.5");
                tlIntroWhiteBg.to(".logo-green", {x: "-=30", y: "+=30", duration: .5});
                tlIntroWhiteBg.to(".logo-blue", {x: "+=30", y: "-=30", duration: .5}, "-=.5");
                tlIntroWhiteBg.to(".segment-white-bg .segment-excerpt", {height: 0, duration: .5}, "-=.25");
                tlIntroWhiteBg.to(".segment-white-bg .segment-details", {
                    height: 'auto',
                    autoAlpha: 1,
                    duration: .5
                }, "-=.25");

                $('.segment-white-bg .segment-toggle').on('click', function () {
                    $(this).children('.toggle').toggleClass('open');

                    if (introWhiteBgState === false) {
                        tlIntroWhiteBg.play();
                        introWhiteBgState = true;
                    } else {
                        tlIntroWhiteBg.reverse();
                        introWhiteBgState = false;
                    }

                });

                //Intro blue bg animation

                var tlIntroBlueBg = gsap.timeline({paused: true});
                tlIntroBlueBg.to(".segment-white-bg", {autoAlpha: 0, duration: .5});
                tlIntroBlueBg.to(".homepage-skew", {y: "-=250", duration: .5}, "-=.25");
                tlIntroBlueBg.to(".intro-image", {x: "-=300", scaleX: 0.75, scaleY: 0.75, duration: .5}, "-=.5");
                tlIntroBlueBg.to(".logo-green", {x: "-=30", y: "+=30", duration: .5});
                tlIntroBlueBg.to(".logo-blue", {x: "+=30", y: "-=30", duration: .5}, "-=.5");
                tlIntroBlueBg.to(".segment-blue-bg .segment-excerpt", {height: 0, duration: .5}, "-=.25");
                tlIntroBlueBg.to(".segment-blue-bg .segment-details", {
                    height: 'auto',
                    autoAlpha: 1,
                    duration: .5
                }, "-=.25");

                $('.segment-blue-bg .segment-toggle').on('click', function () {
                    $(this).children('.toggle').toggleClass('open');

                    if (introBlueBgState === false) {
                        tlIntroBlueBg.play();
                        introBlueBgState = true;
                    } else {
                        tlIntroBlueBg.reverse();
                        introBlueBgState = false;
                    }

                });

            } else {
                $('.segment-white-bg .segment-toggle').on('click', function () {
                    $(this).children('.toggle').toggleClass('open');
                    $(this).siblings('.segment-excerpt').slideToggle();
                    $(this).siblings('.segment-details').slideToggle();
                });

                $('.segment-blue-bg .segment-toggle').on('click', function () {
                    $(this).children('.toggle').toggleClass('open');
                    $(this).siblings('.segment-excerpt').slideToggle();
                    $(this).siblings('.segment-details').slideToggle();
                });
            }

            $('.cases-menu li a').on('click', function (e) {
                e.preventDefault();
            });

            $('.cases-menu li').on('click', function () {
                var caseIndex = $(this).index();
                $(this).addClass('active').siblings().removeClass('active');
                $('.cases .case').eq(caseIndex).fadeIn(
                    {
                        start: function () {
                            $(this).css({
                                display: "flex"
                            })
                        }
                    }
                ).addClass('active').siblings('.case').hide().removeClass('active');
            });
        }

    });
}(jQuery));
